function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Path_146499",
  d: "M24.274,12.6H23.044A9.161,9.161,0,0,0,14,4.566,8.886,8.886,0,0,0,7.47,7.449a.88.88,0,0,0-.062,1.31.928.928,0,0,0,1.318-.07A7.17,7.17,0,0,1,14,6.386,7.251,7.251,0,0,1,21.207,12.6H19.862c-.677,0-.861.5-.466,1.046l2.1,2.971a.649.649,0,0,0,1.134,0l2.109-2.962C25.136,13.1,24.96,12.6,24.274,12.6ZM3.726,14.718H4.965A9.159,9.159,0,0,0,14,22.751a8.9,8.9,0,0,0,6.548-2.892.886.886,0,0,0,.053-1.31.921.921,0,0,0-1.318.079A7.117,7.117,0,0,1,14,20.932a7.249,7.249,0,0,1-7.2-6.214H8.138c.668,0,.861-.5.466-1.046L6.494,10.7a.642.642,0,0,0-1.125,0L3.26,13.663C2.855,14.217,3.04,14.718,3.726,14.718Z",
  transform: "translate(-3.048 -4.566)"
});

function SvgRegeneration(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 21.9 18.185",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegeneration);
export default __webpack_public_path__ + "static/media/regeneration.4e4821b1.svg";
export { ForwardRef as ReactComponent };